import { render } from "./inputBreed.vue?vue&type=template&id=50223434&scoped=true&ts=true"
import script from "./inputBreed.vue?vue&type=script&lang=ts"
export * from "./inputBreed.vue?vue&type=script&lang=ts"

import "./inputBreed.vue?vue&type=style&index=0&id=50223434&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50223434"]])

export default __exports__